import CryptoJS from 'crypto-js';

const ENC_ALGO = 'aes-256-cbc';
const ENC_KEY = '245cb67cff1a1deb6dfd5e6e8bfd030c7fc24601835e42e9bf54d303b5c9c4d9'; // Replace with your actual key in HEX format

export const encryptData = (responseData) => {
  // Generate a random Initialization Vector (IV)
  const iv = CryptoJS.lib.WordArray.random(16); // Generate a random 16-byte IV

  // Convert the key from HEX to WordArray format
  const key = CryptoJS.enc.Hex.parse(ENC_KEY);

  // Encrypt the JSON data
  const encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(responseData),
    key,
    { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
  );

  // Prepare the result
  const result = {
    data: encrypted.toString(), // Encrypted data
    i: iv.toString(CryptoJS.enc.Hex) // IV as Hex string
  };

  return JSON.stringify(result);
}


export const decryptData = (encryptedData) => {
  try {
    
    // Parse the encrypted data and IV from the input
    const { data, i: ivHex } = encryptedData;
    
    // Convert the key from HEX to WordArray format
    const key = CryptoJS.enc.Hex.parse(ENC_KEY);
    
    // Convert the IV from Hex string to WordArray
    const iv = CryptoJS.enc.Hex.parse(ivHex);

    // Ensure the data is properly decoded (if it's base64 encoded)
    const decodedData = CryptoJS.enc.Base64.parse(data);

    
    // Decrypt the data
    const decrypted = CryptoJS.AES.decrypt({ ciphertext: decodedData }, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    // Check if decryption was successful
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    if (!decryptedText) {
      throw new Error('Decryption failed or the result is empty.');
    }

    // Parse the decrypted data to JSON and return it
    const decryptedData = JSON.parse(decryptedText);
    
    return decryptedData;
    
  } catch (error) {
    console.error('Decryption failed:', error);
    return null;
  }
}

